import { render, staticRenderFns } from "./SupplierDataForm.vue?vue&type=template&id=d0ef8596&"
import script from "./SupplierDataForm.vue?vue&type=script&lang=js&"
export * from "./SupplierDataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports